import { ModelMixin } from '@app/models/core/base-generic.model';
import { ProductPlan } from '@models/settings/billing/product-plan.model';

export class Product extends ModelMixin<Product>() {
    protected static _resource = 'billingProducts';

    protected static _version = 'v2';

    get name(): string {
        return this._attributes['name'];
    }

    get unitLabel(): string {
        return this._attributes['unitLabel'];
    }

    get metadata(): any {
        return this._attributes['metadata'];
    }

    get perEmployee(): boolean {
        return this.unitLabel?.toLowerCase() === 'employee';
    }

    get description(): string {
        if (!this._attributes['metadata']['description']) {
            return 'No description is available for this product';
        }

        return this._attributes['metadata']['description'];
    }

    get defaultPlan(): ProductPlan | undefined {
        if (!this._attributes['metadata']['defaultPlan']) {
            return this.productPlans[0];
        }
        const defaultPlanIdentifier = this._attributes['metadata']['defaultPlan'];

        return this.productPlans.find((productPlan) => productPlan.identifier === defaultPlanIdentifier);
    }

    set productPlans(val: ProductPlan[]) {
        this.setMany('productPlans', val);
    }

    get productPlans(): ProductPlan[] {
        return this.hasMany(ProductPlan, 'productPlans');
    }

    get isPublic(): boolean {
        return this.metadata && this.metadata['visibility'] === 'public';
    }

    get isRequired(): boolean {
        return this.name === 'Core HR';
    }
}
